import RestaurantCard from "./restaurantCard";

export default RestaurantCard;
